import FileIconSvgs from '../../icons/FileIconSvgs';
import { FileType } from '../../types/FileType';
const inactiveTint = 'var(--medium-base)';
const svgMapper = {
    [FileType.JPEG]: FileIconSvgs.jpeg,
    [FileType.PDF]: FileIconSvgs.pdf,
    [FileType.TIFF]: FileIconSvgs.tiff,
    [FileType.PNG]: FileIconSvgs.png,
    [FileType.CSV]: FileIconSvgs.csv,
    [FileType.XLS]: FileIconSvgs.excel,
    [FileType.XLSX]: FileIconSvgs.excel,
    [FileType.ZIP]: FileIconSvgs.zip,
    [FileType.CSV_EXTENSION]: FileIconSvgs.csv,
    [FileType.XLS_EXTENSION]: FileIconSvgs.excel,
    [FileType.XLSX_EXTENSION]: FileIconSvgs.excel,
    [FileType.PDF_EXTENSION]: FileIconSvgs.pdf,
};
const FileIcon = ({ fileType, size = 24, inactive = false, }) => {
    const tint = inactive ? inactiveTint : undefined;
    const svg = svgMapper[fileType] || FileIconSvgs.placeholder;
    return svg(size, tint);
};
export default FileIcon;
